import React from 'react'
import ReactDOM from 'react-dom'
import {Autocomplete} from './tefterAutocomplete.jsx';

// In non mobile screens desktop autocomplete form is visible. We check the
// desktop-form-autocomplete element and only if it is visible we render the
// auocomplete element.
if (getComputedStyle(document.getElementById('desktop-form-autocomplete'), null).display != 'none') {
  ReactDOM.render(<Autocomplete formID="desktop-form-autocomplete" />, document.getElementById('autocomplete'));
}
